import { render } from "./ProductCard.vue?vue&type=template&id=438ae600&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=438ae600&lang=scss&scoped=true"

import exportComponent from "/opt/vr23-npm/htdocs/templates/vr23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438ae600"]])

export default __exports__